import React from 'react'
import GiftSubscriptionForm from '../components/GiftSubscriptionForm'

export default function GiftSubscription() {
  return <GiftSubscriptionForm promoPriceId={'price_1M2jL1KA8M9CmmC1GfxudOh6'} />
}
